import fromQueryString from './fromQueryString';

const getQueryOptions = queryOptions => {
  const queryString = window.location.search.substring(1);
  return fromQueryString(queryString, queryOptions);
};

export default getQueryOptions;
